import {PHIEU_IN_ENDPOINT, WF_TRACKER} from "../../../../utils/Constant";
import {TypeKeHoach} from "../models/KeHoachModel";

export const WMS_STATUS = {
  build_plan: "build_plan",
  directDownline: "directDownline",
  build_plan_approved: "build_plan_approved",
};

export const CODE_KE_HOACH = {
  KHHT: 'khht',
  KHCG: 'khcg',
  KHHC: 'khhc',
}

export const TYPE_KE_HOACH: TypeKeHoach[] = [
  {
    name: 'Chuyển giao kỹ thuật',
    code: CODE_KE_HOACH.KHCG,
    formThongTinChung: 'dohaquaylykehoach',
    formVatTu: 'dohaquaylykehoachkythuatchuyengiao',
    pathApi: 'dohaquaylykehoach',
    pathApiPrint:'',
    trackerCode: WF_TRACKER.BUILD_PLAN,
    termModelType: "directDownline",
    type: 1,
    typeKhaoSat: 4,
    trackerCodeKhaoSat: WF_TRACKER.SURVEY_TECHNIQUE_TRANFER,
  },
  {
    name: 'Hỗ trợ kỹ thuật chuyên môn',
    code: CODE_KE_HOACH.KHHT,
    formThongTinChung: 'dohaquaylykehoach',
    formVatTu: 'dohaquaylykehoachkythuathotro',
    pathApi: 'dohaquaylykehoach',
    pathApiPrint:'',
    trackerCode: WF_TRACKER.BUILD_PLAN,
    termModelType: "directDownline",
    type: 2,
    typeKhaoSat: 5,
    trackerCodeKhaoSat: WF_TRACKER.SURVEY_TECHNIQUE_SUPPORT,
  },
  {
    name: 'Hội chẩn KCB từ xa',
    code: CODE_KE_HOACH.KHHC,
    formThongTinChung: 'dohaquaylykehoach',
    formVatTu: 'dohaquaylykehoachthongtincabenh',
    pathApi: 'dohaquaylykehoach',
    pathApiPrint:'',
    trackerCode: WF_TRACKER.BUILD_PLAN,
    termModelType: "directDownline",
    type: 3,
  },
];
